// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-line-wrapper_bf594b1e {
  position: relative;
  flex-grow: 1;
  min-width: 0;
}
.scroll-line-container_bf594b1e {
  position: relative;
  bottom: auto;
  left: auto;
  height: 1.334rem;
}
.scroll-line-container_bf594b1e .os-theme.os-theme {
  --os-padding-axis: 0;
  right: 0;
}
.data-table__data_no-scroll_bf594b1e {
  overflow: hidden;
}
.data-table__scroll_bf594b1e {
  overflow: clip !important;
  min-width: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll-line-wrapper": `scroll-line-wrapper_bf594b1e`,
	"scroll-line-container": `scroll-line-container_bf594b1e`,
	"data-table__data_no-scroll": `data-table__data_no-scroll_bf594b1e`,
	"data-table__scroll": `data-table__scroll_bf594b1e`
};
export default ___CSS_LOADER_EXPORT___;
